import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '../hooks/use-auth'
import { useAuthStore } from '../store/auth-store'
import type { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuth()
  const loadUser = useAuthStore((state) => state.loadUser)

  useEffect(() => {
    if (!isAuthenticated) {
      navigate({ to: '/login' })
    } else if (!user) {
      // Load user if authenticated but user data is missing (e.g., after page refresh)
      loadUser().catch(() => {
        // If loading user fails (e.g., invalid token), logout
        useAuthStore.getState().logout()
        navigate({ to: '/login' })
      })
    }
  }, [isAuthenticated, user, navigate, loadUser])

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
}
